// docs
export const LINK_DOCS_EN = 'https://docs.bifrostnetwork.com/eng.btcfi.one/';
// app
export const LINK_BIFI_LANDING = 'https://bifi.finance';
export const LINK_BDAO = 'https://www.withtally.com/governance/bifi';
export const LINK_GBIFI_SWAP = 'https://gov.bifi.finance';
// family
export const LINK_BIFROST = 'https://bifrostnetwork.com/';
export const LINK_GITHUB = 'https://github.com/bifrost-platform';
export const LINK_DISCORD = 'https://discord.gg/bifrostcity';

export const LINK_FAUCET = 'https://bifrostnetwork.com/faucet';
export const LINK_FEEDBACK = 'https://discord.gg/bifrostcity';

// vip
export const LINK_VIP = 'https://vip.btcfi.one';
export const LINK_VIP_BORROW = 'https://vip.btcfi.one/borrow';

// base ecosystem
export const DOMAIN_BASE = 'base.org';
